import {
  CardWithIcon,
  ContentSection,
  CustomListItem,
} from '@cinch-labs/design-system'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'
import { StoryBlokRichText } from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import styles from './why-cinch.module.css'
import { isStoryblokRichText } from '../util'

export interface WhyCinchCardComponentProps {
  name: string
  title: string
  icon: IconNames
  body: StoryBlokRichText | React.ReactNode
}

const WhyCinchCardComponent: React.FC<WhyCinchCardComponentProps> = ({
  name,
  title,
  icon,
  body,
}) => {
  return (
    <CustomListItem
      key={name}
      bullet={
        <CardWithIcon
          className={styles['cardWithIcon']}
          iconName={icon as IconNames}
          iconColor="vividViolet"
          iconSize={37}
        />
      }
    >
      <ContentSection
        title={title}
        classNames={{
          title: styles['contentSectionTitle'],
          body: styles['contentSectionBody'],
        }}
        sectionWrapperClass={styles['contentSectionWrapper']}
      >
        <div>{isStoryblokRichText(body) ? renderWithResolver(body) : body}</div>
      </ContentSection>
    </CustomListItem>
  )
}

export default WhyCinchCardComponent
